<template>
  <a-entity>
    <a-plane
      color="black"
      scale="0 0 0"
      :width="size.w"
      :height="size.h"
      opacity=".4"
      ref="music"
      material="shader: flat; depthTest: false"
      @loaded="musicLoaded">
      <Timeline v-if="ready" ref="timeline" :name="name" :sprite="sprite" :id="id" :musicKey="musicKey" />
    </a-plane>
    <Player v-if="ready" :key="musicKey" :name="name" :sprite="sprite" />
    <transition @leave="leaveLock">
      <a-plane
        ref="lock"
        v-if="$route.meta.name == 'lock'"
        metarial="shader: flat"
        color="#fc1f1f"
        width="8"
        height="8"
        opacity="1"
        material="shader: flat"
        transparent="true"
        position="0 0 .01">
        <a-plane
          ref="lock_text"
          material="shader: flat"
          @materialtextureloaded="showLock"
          opacity="0"
          v-if="musicReady"
          :src="$root.$agent.mobile && orientation == 'portrait' ? cdn(require('./img/lock-' + lang + '-portrait.png')) : cdn(require('./img/lock-' + lang + '.png'))"
          :width="$root.$agent.mobile && orientation == 'portrait' ? .6 : .4"
          :height="$root.$agent.mobile && orientation == 'portrait' ? .6 : .4"
          transparent="true"
          position="0 -.05 .001"
        />
      </a-plane>
    </transition>
  </a-entity>
</template>

<script>
import Timeline from './Timeline'
import Player from './Player'
import Settings from '@/config/Settings'
import Music from './Howler.js'

export default {
  name: 'Music',
  components: { Timeline, Player },
  translations: {
    fr: { unlock: 'entrer' },
    en: { unlock: 'enter' },
  },
  data: () => ({
    where: 'camera',
    size: {
      w: .7,
      h: .08,
    },
    checkPos: [{
      ref: 'music',
      desktop: { x:0, y:-.43, z: .001 },
      mobile: { y: -.445 },
      landscape: { y: -.245 },
    }],
    musicReady: false,
    id: null,
    type: 'normal',
    name: null,
    sprite: null,
    ready: false,
    explorer: {
      id: 0,
      seek: null,
    },
  }),
  watch: {
    '$route': 'setMusic',
    orientation: 'setSize',
    vr: 'setWorldPosition'
  },
  created() {
    this.setSize()

    this.$musics = this.$root.locked ? Music('webkit') : Music()

    if(this.$root.locked) {
      this.$musics.webkit.once('load', () => {
        this.musicReady = true
        document.addEventListener('touchend', this.lock)
        document.addEventListener('click', this.lock)
      })
    }
  },
  beforeDestroy() {
    if(this.$rafId)
      cancelAnimationFrame(this.$rafId)
  },
  methods: {
    setSize() {
      this.size.w = .7
      this.size.h = .08

      if(this.vr)
        this.size.w = .6

      if(this.$root.$agent.mobile && !this.vr) {
        this.size.w = .33
        this.size.h = .05
        if(this.orientation == 'landscape')
          this.size.w = .5
      }
    },
    musicLoaded() {
      this.setDyniquePos()
      this.setMusic()
    },
    lock() {
      this.$root.locked = false
      this.type = 'webkit'
      this.id = this.$musics['webkit'].play()
      this.removeLock()
    },
    removeLock(){
      document.removeEventListener('click', this.lock)
      document.removeEventListener('touchend', this.lock)
      this.$router.push({ name: this.$root.redirect.name, params: this.$root.redirect.params })
    },
    showLock() {
      TweenLite.to(this.$refs.lock_text, 1, { aframe: { alpha: 1 }})
    },
    leaveLock(el, done) {
      TweenLite.to(this.$refs.lock_text, 1, { aframe: { alpha: 0 }})
      TweenLite.to(this.$refs.lock, 2, { aframe: { alpha: 0 }, onComplete: done})
    },
    setMusic() {
      if(this.$root.locked) return

      const routeName = this.$route.meta.name
      const level = this.$route.params.level
      const captation = this.$route.params.captation

      if(routeName == 'lock') {
        if(this.type == 'webkit' && this.$musics['webkit'].state() == 'loaded') {
          document.addEventListener('touchend', this.removeLock)
          document.addEventListener('click', this.removeLock)
        }
      }

      let name = 'ambiences'
      let sprite = 'SplashBoucle'

      if(routeName == 'start' || routeName == 'level' || routeName == 'conclusion') name = 'narrations_' + this.lang

      if(routeName == 'explorer') sprite = 'FinBoucle'
      if(routeName == 'start') sprite = 'Intro_Part1'
      if(routeName == 'level') sprite = 'Grappe' + level
      if(routeName == 'conclusion') sprite = 'Conclusion'
      if(routeName == 'captation' && !captation) sprite = 'Grappe' + level + '_Boucle'

      if(routeName == 'captation' && captation) {
        name = captation == 'intro-3' ? 'narrations_' + this.lang : 'captations'
        sprite = captation == 'intro-3' ? 'Intro_Part2' : captation
      }

      this.name = name
      this.sprite = sprite
      this.musicKey = name + sprite

      this.ready = true

      this.setWorldPosition()
    },
    setWorldPosition() {
      const child = this.$refs.music.object3D
      const parent = this.$el.object3D
      const scene = this.$el.sceneEl.object3D
      const routeName = this.$route.meta.name
      let pos = { x: 0, y: 0, z: 0 }

      this.setSize()

      if(this.vr){
        this.where = 'scene'
        // TweenLite.set(this.$refs.music, { aframe: { alpha: 0 } })
        if(routeName == 'level') {
          TweenLite.delayedCall(.2, () => {
            const attachTo = document.querySelector('.TitleLevel.is-' + this.$route.params.level)
            this.detach(child, parent, attachTo.object3D)
            TweenLite.set(this.$refs.music, { aframe: { alpha: 0, scale: 1, rotation: 0, x: 0, y: -.37, z: -.01 }})
          })
        } else if(this.$route.params.captation) {
          const attachTo = document.querySelector('.Captation.is-' + this.$route.params.captation)
          this.detach(child, parent, attachTo.object3D)
          TweenLite.set(this.$refs.music, { aframe: { alpha: 0, scale: 2.5, rotation: 0, x: 0, y: -1.25, z: 0  }})
          TweenMax.from(this.$refs.music, 1, { aframe: { scale: 0 }})
        } else {
          TweenMax.to(this.$refs.music, 1, { aframe: { scale: 0 }})
        }
      } else {
        if(this.where != 'camera') {
          this.where = 'camera'
          // TweenLite.set(this.$refs.music, { aframe: { alpha: .6 } })
          this.attach(child, scene, parent)
          TweenLite.set(this.$refs.music, { aframe: { alpha: .4, scale: 1, rotation: 0, ...pos }})
          this.setDyniquePos()
        }
        TweenMax.to(this.$refs.music, 1, { aframe: { scale: this.name == 'ambiences' ? 0 : 1 }})
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/music/Music.vue